var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.AppLayout,
    { attrs: { pageTitle: "Campaigns" } },
    [
      _c("v-data-table", {
        ref: "table",
        staticClass: "cursor-pointer",
        attrs: {
          headers: _setup.headers,
          items: _vm.campaigns,
          "hide-default-footer": "",
          "disable-pagination": "",
          "mobile-breakpoint": "0",
        },
        on: {
          "click:row": function ($event) {
            return _setup.handleSelect($event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }